/* post-t7-2b (remate de D1 y D7): LO QUE EL ESQUELETO DEL PANEL "AVANCE DEL GRUPO" RESERVA ANTES DE TENER LOS DATOS.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   (1) La barra de computadora mide, medido en Chrome con el chasis real: relleno 8 + 8, borde de 1, el renglon 1 (el
   boton de regresar: 36, o mas si su nombre parte renglon dentro), el hueco de 6 y el renglon 2 (el boton del chat, 36;
   sin chat, el titulo en un renglon de 13 x 1.5 = 19.5). Con chat 95, sin chat 78.5, con el nombre en dos renglones
   108.8. Antes el esqueleto reservaba 79 siempre, y con el chat encendido la pagina bajaba 15.6 px al llegar los datos
   (29.4 con el nombre partido). El chat se enciende con una perilla GLOBAL: el esqueleto usa el ultimo valor visto en
   este navegador y, si nunca vio ninguno, lo da por encendido. El nombre del grupo no se conoce antes de los datos: el
   esqueleto lo da por un renglon, salvo que ya haya visto la barra de ESE grupo a ese mismo ancho e idioma (entonces
   reserva el alto que midio).
   (2) El subtitulo: el ultimo visto de ese grupo en ese idioma (o, la primera vez, el de un grupo tipico).

   Lo recordado vive en `localStorage` (llave `sb_avance_esqueleto`), sin nombres de personas ni de grupos: el valor del
   chat y, por id de grupo, el subtitulo por idioma y el alto de la barra con el ancho y el idioma en que se midio. Hasta
   `TOPE_DE_GRUPOS` grupos. Si el almacenamiento falla (ventana privada, bloqueado), todo sigue funcionando sin recordar. */

/** Las medidas de la barra de computadora (ver arriba). */
export const MEDIDAS_DE_LA_BARRA_DE_COMPUTADORA = {
  relleno: 8, borde: 1, hueco: 6, boton: 36, chat: 36, titulo: 19.5,
  // un renglon del nombre dentro del boton: letra de 13 con interlineado 1.3; el boton suma su relleno (7 + 7) y su borde
  renglonDelNombre: 13 * 1.3, rellenoYBordeDelBoton: 7 * 2 + 1 * 2,
};

/** El alto de la barra de computadora: con o sin el boton del chat, y con el nombre en `renglones` renglones. */
export function altoDeLaBarraDeComputadora({ chat = true, renglones = 1 } = {}) {
  const M = MEDIDAS_DE_LA_BARRA_DE_COMPUTADORA;
  const renglon1 = Math.max(M.boton, renglones * M.renglonDelNombre + M.rellenoYBordeDelBoton);
  const renglon2 = chat ? M.chat : M.titulo;
  return Math.round((M.relleno * 2 + M.borde + renglon1 + M.hueco + renglon2) * 10) / 10;
}

export const LLAVE_DEL_ESQUELETO = 'sb_avance_esqueleto';
export const TOPE_DE_GRUPOS = 30;

let enMemoria = null;

function leer() {
  if (enMemoria) return enMemoria;
  let x = null;
  try {
    x = JSON.parse(window.localStorage.getItem(LLAVE_DEL_ESQUELETO) || 'null');
  } catch (e) {
    x = null;
  }
  const grupos = x && x.grupos && typeof x.grupos === 'object' ? x.grupos : {};
  enMemoria = { chat: x && typeof x.chat === 'boolean' ? x.chat : null, grupos };
  return enMemoria;
}

function guardar() {
  try {
    window.localStorage.setItem(LLAVE_DEL_ESQUELETO, JSON.stringify(enMemoria));
  } catch (e) {
    // sin almacenamiento: se recuerda solo mientras la pagina sigue abierta
  }
}

/** El ultimo valor visto del chat; sin ninguno, encendido. */
export function chatRecordado() {
  return leer().chat !== false;
}

export function recordarChat(valor) {
  const m = leer();
  if (m.chat === !!valor) return;
  m.chat = !!valor;
  guardar();
}

/** Lo recordado de un grupo: `{ sub: { es, en }, barra: { lang, W, alto } }` o null. */
export function recuerdoDelGrupo(id) {
  const g = id ? leer().grupos[id] : null;
  return g && typeof g === 'object' ? g : null;
}

/** Recuerda el subtitulo de un grupo en un idioma y, si se da, el alto de su barra de computadora. */
export function recordarDelGrupo(id, { lang, subtitulo, barra } = {}) {
  if (!id) return;
  const m = leer();
  const antes = m.grupos[id] || {};
  const sub = { ...(antes.sub || {}) };
  if (lang && typeof subtitulo === 'string') sub[lang] = subtitulo;
  const nuevo = { sub, barra: barra || antes.barra || null };
  if (JSON.stringify(nuevo) === JSON.stringify(antes)) return;
  delete m.grupos[id];
  m.grupos[id] = nuevo;
  const ids = Object.keys(m.grupos);
  for (const viejo of ids.slice(0, Math.max(0, ids.length - TOPE_DE_GRUPOS))) delete m.grupos[viejo];
  guardar();
}

/** El alto que reserva el esqueleto para la barra de computadora de un grupo, con el ancho `W` y el idioma `lang`. */
export function altoReservadoDeLaBarra(id, W, lang) {
  const g = recuerdoDelGrupo(id);
  const b = g && g.barra;
  if (b && b.lang === lang && Math.abs((b.W || 0) - W) < 1 && b.alto > 0) return b.alto;
  return altoDeLaBarraDeComputadora({ chat: chatRecordado() });
}

/** Solo para las pruebas: olvida lo leido (la siguiente lectura vuelve al almacenamiento). */
export function olvidarLoLeido() {
  enMemoria = null;
}
